export const formatEffectiveDate = (dateString: string): string => {
    if (!dateString) return ''
    const date = new Date(dateString)
    const month = String(date.getUTCMonth() + 1).padStart(2, '0')
    const day = String(date.getUTCDate()).padStart(2, '0')
    const year = String(date.getUTCFullYear()).slice(-2)
    return `${month}/${day}/${year}`
}

export const formatFullTimestamp = (dateString: string): string => {
    if (!dateString) return ''
    const date = new Date(dateString)
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const year = String(date.getFullYear()).slice(-2)
    
    let hours = date.getHours()
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0')
    const ampm = hours >= 12 ? 'PM' : 'AM'
    
    hours = hours % 12
    hours = hours ? hours : 12 // 0 should be 12
    const hoursStr = String(hours).padStart(2, '0')
    
    return `${month}/${day}/${year} ${hoursStr}:${minutes}:${seconds}.${milliseconds} ${ampm}`
}
